import Backbone from 'backbone';
import { reflow } from './util';

const Overlay = Backbone.View.extend({
  activeZIndex: 0,
  events: {
    'click': 'onOverlayClick',
  },
  initialize() {
    this.initListeners();
  },
  initListeners() {
    this.boundOnKeyup = this.onKeyup.bind(this);
    this.boundOnFadeInTransitionStart = this.onFadeInTransitionStart.bind(this);
    this.boundOnFadeInTransitionEnd = this.onFadeInTransitionEnd.bind(this);
    this.boundOnFadeOutTransitionEnd = this.onFadeOutTransitionEnd.bind(this);
    this.listenTo(Backbone, {
      'membership-nav:menu:open':   this.show,
      'membership-nav:menu:close':  this.hide,
      'primary-nav:submenu:open':      this.show,
      'primary-nav:submenu:close':     this.hide
    });
  },
  show(eventData) {
    this.clearTransitionEndListeners();

    if (hasOwnProperty.call(eventData, 'zIndex')) this.activeZIndex = eventData.zIndex - 1;

    this.el.style.display = 'block';
    reflow(this.el);
    this.el.setAttribute('data-active', true);
    this.el.classList.add(`layout/z-index:${this.activeZIndex}`);

    this.el.addEventListener('transitionstart', this.boundOnFadeInTransitionStart);
    this.el.addEventListener('transitionend', this.boundOnFadeInTransitionEnd);
    document.addEventListener('keyup', this.boundOnKeyup, this);
  },
  isActive() {
    return document.body.classList.contains('layout/overflow:hidden');
  },
  hide() {
    this.clearTransitionEndListeners();

    this.el.removeAttribute('data-active');
    this.el.addEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
    document.removeEventListener('keyup', this.boundOnKeyup, this);
  },
  clearTransitionEndListeners() {
    this.el.removeEventListener('transitionstart', this.boundOnFadeInTransitionStart);
    this.el.removeEventListener('transitionend', this.boundOnFadeInTransitionEnd);
    this.el.removeEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
  },
  onOverlayClick() {
    Backbone.trigger('overlay:click');
  },
  onFadeInTransitionStart() {
    this.el.removeEventListener('transitionstart', this.boundOnFadeInTransitionStart);
    document.body.setAttribute('data-overlay-active', true);
  },
  onFadeInTransitionEnd() {
    this.el.removeEventListener('transitionend', this.boundOnFadeInTransitionEnd);
    document.body.classList.add('layout/overflow:hidden');
  },
  onFadeOutTransitionEnd() {
    this.el.removeEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
    this.el.style.display = 'none';
    this.el.classList.remove(`layout/z-index:${this.activeZIndex}`);
    document.body.removeAttribute('data-overlay-active');
    document.body.classList.remove('layout/overflow:hidden');
  },
  onKeyup(e) {
    if (this.isActive() && e.key === 'Escape') Backbone.trigger('overlay:cancel');
  },
  dispose() {
    this.hide();
    this.el.classList.remove(`layout/z-index:${this.activeZIndex}`);
    this.clearTransitionEndListeners();
    this.undelegateEvents();
    this.stopListening();
  },
});

export default Overlay;
